/**
 * Newsletter mailbox read state.
 *
 * Implementation moved to `useReadState` (cross-device sync via an encrypted
 * `kind-30078` event) while preserving the same instant localStorage fast-path
 * and the same public API (`{ lastRead, markNewsletterRead }`). Re-exported
 * here so existing imports keep working unchanged.
 */
export { useNewsletterRead } from '@/hooks/useReadState';
